import { cn } from '@/lib/utils';
import {
  IconAdornment,
  type IconAdornmentComponentProps,
} from '@/components/IconAdornment';
import styles from './Input.module.css';

export interface InputProps
  extends
    React.InputHTMLAttributes<HTMLInputElement>,
    Omit<IconAdornmentComponentProps, 'children'> {
  error?: string;
  onIconClick?: () => void;
  /** Selects the full value on focus — useful for pre-filled "rename" style inputs
   * so a long value isn't left with the caret buried at the end. */
  selectOnFocus?: boolean;
  ref?: React.Ref<HTMLInputElement>;
}

export function Input({
  IconPrefix = null,
  IconSuffix = null,
  className = '',
  error,
  onIconClick,
  disabled = false,
  selectOnFocus = false,
  onFocus,
  ...props
}: InputProps) {
  return (
    <IconAdornment
      IconPrefix={IconPrefix}
      IconSuffix={IconSuffix}
      onIconClick={onIconClick}
    >
      <input
        disabled={disabled}
        className={cn(
          'w-full',
          styles.inputBase,
          disabled && styles.inputDisabled,
          IconPrefix && styles.inputHasPrefix,
          IconSuffix && styles.inputHasSuffix,
          error && styles.inputError,
          className
        )}
        onFocus={(e) => {
          if (selectOnFocus) e.target.select();
          onFocus?.(e);
        }}
        {...props}
        value={props.value ?? ''}
      />
    </IconAdornment>
  );
}
